import React, { Component } from "react";

class ShowNews extends Component {

    state = {articles: {}, isLoaded: false};

    fetchData = () => {
        // reset the state in case "more news" button was clicked
        this.setState({isLoaded: false});
        console.log("fetching data");
        fetch("https://newsdata.io/api/1/news?apikey=pub_101023249e5465451713483a2c9975ee0a196&language=en&country=us")
        // fetch("https://jsonplaceholder.typicode.com/users")
        .then(response => response.json())
        .then(json => {
            this.setState({articles: json, isLoaded: true});
        }).catch(error => {
            alert("External API service returned an error!", error.message);
        });
    }

    componentDidMount() {
        this.fetchData();
    }

    render() {
        const {articles, isLoaded} = this.state;
        console.log(articles);
        if(!isLoaded) {
            return (
                <div>
                    <p>Gathering data from external API service, please wait...</p>
                </div>
            );
        }
        if(articles.status==="error") {
            return (
                <div>
                    <p>An error has occured, too many free API requests today!</p>
                    <p><i>I am using a free external API service that only limits me to a certain number of requests per day, please try again tomorrow</i></p>
                </div>
            )
        }
        if(articles.status==="success") {
            return (
                <div>
                    {
                        articles.results.map(article => (
                            <div key={article.link}>
                                <a href={article.link} ><h3>{article.title}</h3></a>
                                <b><i><p>From {article.source_id} - at {article.pubDate}</p></i></b>
                                <p>{article.description}</p>
                            </div>
                        ))
                    }
                    <button className="btn btn-primary text-center" onClick={this.fetchData}>Load more news</button>
                </div>
            )
        }
    }
}

export default ShowNews;